import type { ICloudRegulatoryControlPoint } from "../types"
import type { RegulatoryDisplayCategory } from "../types/regulatory"
export const unclassified: RegulatoryDisplayCategory = {
  code: "unclassified",
  legacyCode: 0,
  scope: "any",
  label: "Non classé",
  iconKey: "05_affichage_et_autre",
  sortOrder: 999,
}
export function categoryOf(point: ICloudRegulatoryControlPoint) {
  return point.DisplayCategory ?? unclassified
}
export function categoryGroups(points: ICloudRegulatoryControlPoint[]) {
  const groups = new Map<
    string,
    { category: RegulatoryDisplayCategory; points: ICloudRegulatoryControlPoint[] }
  >()
  for (const point of points) {
    const category = categoryOf(point)
    if (!groups.has(category.code)) groups.set(category.code, { category, points: [] })
    groups.get(category.code)!.points.push(point)
  }
  return Array.from(groups.values()).sort(
    (a, b) =>
      a.category.sortOrder - b.category.sortOrder || a.category.code.localeCompare(b.category.code),
  )
}

export function contextCategoryPoints(points: ICloudRegulatoryControlPoint[]) {
  const contexts = new Map<string, ICloudRegulatoryControlPoint[]>()
  for (const p of points) {
    const key = p.AnswerContextUUID ?? ""
    if (!contexts.has(key)) contexts.set(key, [])
    contexts.get(key)!.push(p)
  }
  return Array.from(contexts.values()).flatMap((group) =>
    categoryGroups(group).flatMap((c) => c.points),
  )
}
